module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_6000.4655f88f.png";